import React, { useEffect, useContext, useState } from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import Context from 'stores/context';
import PropTypes from 'prop-types';

import {
  ListEmptyBell,
} from 'components';

import ItemWorkout from '../Component/ItemWorkout';

const ListWorkoutWalletStyle = styled.div`
  color: ${props => props.theme.colors.white};
  margin-top: 20px;
  overflow: scroll;
  overflow-x: hidden;
  height: 517px;
`;

const ListWorkoutWallet = (props) => {
  const [reqListExercise, setReqListExercise] = useState(false);
  const context = useContext(Context);
  const {
    teacherTrainingStore,
    appStore,
    modalStore,
    i18n,
    filterWorkoutStore,
    walletUnityStore,
  } = context;

  const {
    history,
  } = props;

  const reloadListExercise = () => {
    setReqListExercise(true);
  };

  useEffect(() => {
    const getListExercise = async () => {
      appStore.toggleloading(true);
      try {
        setReqListExercise(false);

        await walletUnityStore.doRequestListWorkoutUnity({
          id: teacherTrainingStore.programId,
        });

        modalStore.closeModalError();
        appStore.toggleloading(false);
      } catch (error) {
        const msgTitle = i18n.t('error_loading');
        window.scroll(0, 0);
        modalStore.setTitle(msgTitle);
        modalStore.setModalNetworkCallback(reloadListExercise);
        modalStore.showModalError(error);
        appStore.toggleloading(false);
      }
    };

    if (reqListExercise) {
      getListExercise();
    }
  }, [
    modalStore,
    i18n,
    appStore,
    reqListExercise,
    teacherTrainingStore,
    filterWorkoutStore,
    walletUnityStore,
  ]);

  if (walletUnityStore.reloadListExercise) {
    walletUnityStore.resetView();
    walletUnityStore.setReloadListExercise(false);
    reloadListExercise();
  }

  const loadingListWorkout = () => {
    appStore.toggleloading(true);
    setReqListExercise(true);
  };

  const onScroll = (e) => {
    const calc = e.target.scrollHeight - e.target.scrollTop;
    const heightClient = e.target.clientHeight + 1;
    const finish = walletUnityStore.finishListSuggestionWallet;
    const result = (calc <= heightClient && finish === false);
    const finishReq = walletUnityStore.finishRequest;

    if (result && reqListExercise === false && finishReq) {
      loadingListWorkout();
    }
  };

  const renderList = () => {
    const workoutComplete = walletUnityStore.listWorkoutWAlletView.filter((exercise) => {
      return exercise.complete;
    });

    const listItems = workoutComplete.map(exercise => (
      <ItemWorkout
        key={exercise.id}
        exercise={exercise}
        tabSelected="training_wallet"
        history={history}
      />
    ));

    return listItems;
  };

  const renderListEmpty = () => {
    const hasListExercise = (walletUnityStore.listWorkoutWAlletView.length > 0);
    const hasFilterSelected = (filterWorkoutStore.lengthSelected > 0);

    if (hasListExercise === false && hasFilterSelected) {
      return (
        <ListEmptyBell
          title={i18n.t('filter_empty')}
        />
      );
    }

    if (hasListExercise === false && hasFilterSelected === false) {
      return (
        <ListEmptyBell
          title={i18n.t('not_found_list')}
        />
      );
    }

    return false;
  };

  return (
    <ListWorkoutWalletStyle onScroll={onScroll} className="wrapper-scroll">
      {renderListEmpty()}
      {renderList()}
    </ListWorkoutWalletStyle>
  );
};

ListWorkoutWallet.defaultProps = {
  history: {},
};

ListWorkoutWallet.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};

export default observer(ListWorkoutWallet);
